import { Dropzone, DropzoneProps } from '@mantine/dropzone'
import clsx from 'clsx'
import { motion } from 'motion/react'
import { type Ref } from 'react'
import toast from 'react-hot-toast'
import styles from './AttachmentDropzone.module.css'

export interface AttachmentDropzoneProps extends DropzoneProps {
	ref?: Ref<HTMLDivElement>
}

export default function AttachmentDropzone({
	children,
	ref,
	className,
	...props
}: AttachmentDropzoneProps) {
	return (
		<Dropzone
			unstyled
			ref={ref}
			{...props}
			onReject={() => {
				toast.error('暂不支持该文件类型')
				toast('请在即刻App中重试')
			}}
			className={clsx(styles.root, className)}
			activateOnClick={false}
		>
			{children}
			<Dropzone.Accept>
				<motion.div
					initial={{
						opacity: 0,
					}}
					animate={{
						opacity: 1,
					}}
					exit={{
						opacity: 0,
					}}
					className={styles.accept}
				>
					拖拽到此处上传
				</motion.div>
			</Dropzone.Accept>
		</Dropzone>
	)
}
